import * as React from "react";
import { Button, Dropdown, Option } from "@fluentui/react-components";

export interface PaginationProps {
  currentPage: number;
  totalItems?: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  pageSizeOptions?: number[];
  canStepForward?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50, 100],
  canStepForward,
}) => {
  const pageCount: number | undefined =
    totalItems === undefined
      ? undefined
      : Math.max(1, Math.ceil((totalItems ?? 0) / pageSize));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 12,
        alignItems: "center",
        marginBottom: 12,
      }}
    >
      {onPageSizeChange ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Dropdown
            value={String(pageSize)}
            onOptionSelect={(_, data) =>
              onPageSizeChange(Number(data.optionValue))
            }
            style={{ minWidth: 80 }}
          >
            {pageSizeOptions.map((ps) => (
              <Option key={ps} value={String(ps)} text={String(ps)} />
            ))}
          </Dropdown>
          <span style={{ fontSize: 13 }}>találat oldalaként</span>
        </div>
      ) : null}

      <Button
        disabled={currentPage <= 1}
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
      >
        Előző
      </Button>

      <span style={{ alignSelf: "center" }}>
        {totalItems === undefined
          ? `Oldal ${currentPage}`
          : `Oldal ${currentPage} / ${pageCount}`}
      </span>

      <Button
        disabled={
          pageCount === undefined ? !canStepForward : currentPage >= pageCount
        }
        onClick={() =>
          pageCount === undefined
            ? onPageChange(currentPage + 1)
            : onPageChange(Math.min(pageCount, currentPage + 1))
        }
      >
        Következő
      </Button>
    </div>
  );
};

export default Pagination;
